$(function() {
  $(document).on('click', '.insert-number', function(e) {
    e.preventDefault();
    var $el = $(this);
    var $textarea = $('#{0}'.format($el.data('el')));
    $textarea.insertAtCaret($el.text().trim());
  });
});
